import {
  Grid,
  Pagination,
  PaginationItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import React, { useEffect } from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import { ColumnModel, PageInfoModel } from "../../models/common.model";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { GetSupplierBranchUserResponse } from "../../models/supplierUserBarnch.model";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  getTablePage,
  getTableSelectedRow,
} from "../../redux/table/tableSlice";
import { useHistory } from "react-router-dom";

const columns: readonly ColumnModel[] = [
  { id: "fullName", label: "نام و نام خانوادگی" },
  { id: "nationalCode", label: "کد ملی" },
  { id: "mobileNumber", label: "شماره موبایل" },
  { id: "birthDate_Persian", label: "تاریخ تولد" },
  { id: "isActiveTitle", label: "وضعیت" },
];

const nextIcon = () => {
  return (
    <img
      style={{ height: "12px", width: "10px" }}
      src="images/Next.png"
      alt=""
    />
  );
};
const previusIcon = () => {
  return (
    <img
      style={{ height: "12px", width: "10px" }}
      src="images/Previous.png"
      alt=""
    />
  );
};
const useStyles = makeStyles(() =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: "#CEE5D3 !important",
      },
    },
  })
);

interface Props {
  supplierBranchUserList: GetSupplierBranchUserResponse[];
  pageInfo: PageInfoModel;
  setCurrentPaginationInfo: (page: any) => void;
  currentPaginationInfo: any;
  handelDelete: Function;
  handleEdit: Function;
  handleRouteToBranchDetail: Function;
}
const SupplierBranchUserTable = ({
  currentPaginationInfo,
  pageInfo,
  supplierBranchUserList,
  setCurrentPaginationInfo,
  handelDelete,
  handleEdit,
  handleRouteToBranchDetail,
}: Props) => {
  const classes = useStyles();

  const history = useHistory<any>();
  const dispatch = useDispatch();
  const tableInfo = useSelector((state: any) => state.table);

  const changePageNumber = (newPageNumber: number) => {
    setCurrentPaginationInfo({
      pageNumber: newPageNumber,
      pageSize: 10,
    });
  };
  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    dispatch(
      getTableSelectedRow({
        selectedRowNum: 0,
      })
    );
    dispatch(
      getTablePage({
        selectedPageNum: value,
      })
    );
  };

  useEffect(() => {
    if (history.action === "POP") {
      setCurrentPaginationInfo({
        pageNumber: tableInfo.selectedPageNum,
        pageSize: 10,
      });
    }
  }, [history.action, setCurrentPaginationInfo, tableInfo.selectedPageNum]);
  return (
    <div>
      <div>
        <div className="cardTableBorder">
          <TableContainer
            style={{ background: "#fff", maxHeight: "55vh" }}
            className="boxScroll"
          >
            <Table
              stickyHeader
              aria-label="sticky table"
              style={{ borderCollapse: "collapse" }}
            >
              <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
                <TableRow
                  classes={{ root: classes.select }}
                  className={`${classes} borderRight borderLeft`}
                  selected={tableInfo.selectedRowNum}
                >
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight WidthRowNumber"
                    align="right"
                    style={{ width: "10vh", minWidth: "10vh" }}
                  >
                    ردیف
                  </TableCell>

                  {columns.map((column) => (
                    <TableCell
                      className="rowTHead colorTitle textFont12 fontWeight noWrap"
                      key={column.id}
                      align="right"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight noWrap"
                    sx={{ textAlign: "end !important" }}
                  >
                    <MoreHorizIcon
                      scale="scale(1.8) "
                      style={{ color: "#1D4A87" }}
                    />
                  </TableCell>
                </TableRow>
              </TableHead>
              <div style={{ width: "100%", height: "10px" }}></div>
              <TableBody>
                {supplierBranchUserList
                  ? supplierBranchUserList?.map((row, rowIndex) => {
                      return (
                        <TableRow
                          classes={{ root: classes.select }}
                          className={`${
                            rowIndex % 2 === 0 ? "rowTBodyE  " : "rowTBodyO "
                          } ${classes} borderRight borderLeft cursorPointer noWrap`}
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                          selected={tableInfo.selectedRowNum === rowIndex}
                        >
                          <TableCell
                            className="textFont12 WidthRowNumber"
                            style={{ width: "10vh", minWidth: "10vh" }}
                          >
                            {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                              (currentPaginationInfo.pageSize! ?? 0) +
                              rowIndex +
                              1}
                          </TableCell>
                          {columns.map((column) => {
                            const value =
                              row[
                                column.id as keyof GetSupplierBranchUserResponse
                              ];
                            return (
                              <>
                                {column.id === "isActiveTitle" ? (
                                  <TableCell
                                    className="textFont12"
                                    key={column.id}
                                    align="right"
                                  >
                                    {value === "فعال" ? (
                                      <span style={{ color: "#28A745" }}>
                                        فعال
                                      </span>
                                    ) : (
                                      <span style={{ color: "#E6123D" }}>
                                        غیر فعال
                                      </span>
                                    )}
                                  </TableCell>
                                ) : (
                                  <TableCell
                                    className="textFont12"
                                    key={column.id}
                                    align="right"
                                  >
                                    {!value ? (
                                      <>--</>
                                    ) : column.format && column.hasFormat ? (
                                      column.format(value)
                                    ) : (
                                      value?.toString()
                                    )}
                                  </TableCell>
                                )}
                              </>
                            );
                          })}
                          <TableCell
                            className="textFont12"
                            sx={{ textAlign: "end !important" }}
                          >
                            <Tooltip title="شعبه" arrow>
                              <StoreOutlinedIcon
                                sx={{
                                  color: "#1D4A87",
                                  fontSize: "1.8rem",
                                  cursor: "pointer",
                                  marginInline: "5px",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  dispatch(
                                    getTableSelectedRow({
                                      selectedRowNum: rowIndex,
                                    })
                                  );
                                  handleRouteToBranchDetail(row.id);
                                }}
                              />
                            </Tooltip>
                            <Tooltip title="ویرایش" arrow>
                              <EditOutlinedIcon
                                sx={{
                                  color: "#1D4A87",
                                  fontSize: "1.8rem",
                                  cursor: "pointer",
                                  marginInline: "5px",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  dispatch(
                                    getTableSelectedRow({
                                      selectedRowNum: rowIndex,
                                    })
                                  );
                                  handleEdit(row);
                                }}
                              />
                            </Tooltip>
                            <Tooltip title="حذف" arrow>
                              <DeleteOutlineOutlinedIcon
                                onClick={() => handelDelete(row)}
                                style={{
                                  color: "#1D4A87",
                                  cursor: "pointer",
                                  marginInline: "5px",
                                }}
                              />
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  : null}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {pageInfo && (
          <div>
            <div className="row"></div>
            <Grid container xs={12}>
              <Grid item xs={4}>
                <span
                  style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
                >
                  تعداد کل :
                  <span style={{ color: "#01AF43" }}>
                    {pageInfo.total ?? 0}
                  </span>{" "}
                  مورد
                </span>
              </Grid>
              <Grid item xs={6} md={4}>
                <Pagination
                  renderItem={(item) => (
                    <PaginationItem
                      components={{
                        previous: previusIcon,
                        next: nextIcon,
                      }}
                      {...item}
                    />
                  )}
                  sx={{
                    display: "flex",
                    justifyContent: "center !important",
                    direction: "ltr",
                    margin: "5px",
                    button: {
                      color: "#25D1C9",
                      fontSize: "14px !important",
                      fontFamily: "iranSans",
                    },
                  }}
                  count={
                    pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
                  }
                  onChange={handleChangePagination}
                  page={currentPaginationInfo.pageNumber}
                />
              </Grid>
              <Grid item xs={2} md={4}></Grid>
            </Grid>
          </div>
        )}
      </div>
    </div>
  );
};

export default SupplierBranchUserTable;
